import React from "react";
import styled, { css } from "styled-components";
import { borderWidth, colors, radius } from "../../assets/themes";
import { AVATAR_GROUP } from "@/components/styles/variants/avatar-group";

const StyledChild = styled.div``;

const StyledChildWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledBubbleCount = styled.div`
  ${({ size, orientation }) => css`
    position: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? "absolute" : "relative"};
    top: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? 0 : "auto"};
    right: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? 0 : "auto"};
    min-width: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? `calc(${size} / 1.5)` : size};
    width: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? `calc(${size} / 1.5)` : size};
    min-height: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? `calc(${size} / 1.5)` : size};
    height: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? `calc(${size} / 1.5)` : size};
    margin-left: ${
      orientation === AVATAR_GROUP.ORIENTATION.HORIZONTAL ? `calc(${size} / 2 * -1)` : "auto"
    };
    border-radius: ${radius.circle};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.muted};
    color: ${colors.onColor};
    outline: ${borderWidth.m} solid ${colors.background};
  `}
`;

const StyledGroup = styled.div`
  ${({ orientation, size, outlineColor }) =>
    css`
      ${StyledChild} {
        position: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? "absolute" : "static"};
        top: 0;
        right: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? 0 : "auto"};
        margin-left: calc(${size} / 2 * -1);
        bottom: ${orientation === AVATAR_GROUP.ORIENTATION.HORIZONTAL ? 0 : "auto"};
        left: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? "auto" : 0};
        outline: ${borderWidth.m} solid ${outlineColor};
        border-radius: ${radius.circle};
        &:first-of-type {
          left: 0;
          bottom: 0;
          top: initial;
          right: initial;
          margin-left: 0;
          outline: 0;
          border-radius: ${radius.circle};
        }
      }
    `}
  ${({ size, orientation }) => css`
    position: relative;
    display: flex;
    align-items: center;
    width: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? size : null};
    height: ${orientation === AVATAR_GROUP.ORIENTATION.VERTICAL ? size : null};
  `}
`;

const Group = ({
  children,
  orientation = AVATAR_GROUP.ORIENTATION.VERTICAL,
  outlineColor = colors.background,
  max: _max = 2,
}) => {
  let max = _max;
  if (orientation === AVATAR_GROUP.ORIENTATION.VERTICAL) {
    max = 1;
  }
  const childs = React.Children.toArray(children).splice(0, max);
  const childrenAmount = React.Children.count(children);
  const currSize = childs.map((child) => child.props.size)[0];
  const ChildsElem = () =>
    childs.map((child, index) => (
      <StyledChild key={`avatar-group-${index}`}>
        {React.cloneElement(child, {
          size:
            childrenAmount > 1 && orientation === AVATAR_GROUP.ORIENTATION.VERTICAL
              ? `calc(${child?.props.size} / 1.5)`
              : child?.props.size,
        })}
      </StyledChild>
    ));
  return (
    <StyledGroup
      childrenAmount={childrenAmount}
      max={max}
      orientation={orientation}
      outlineColor={outlineColor}
      size={currSize}
    >
      <StyledChildWrapper>
        <ChildsElem />
      </StyledChildWrapper>
      {childrenAmount > max && (
        <StyledBubbleCount orientation={orientation} size={currSize}>
          +{childrenAmount - max}
        </StyledBubbleCount>
      )}
    </StyledGroup>
  );
};

export default Group;
